import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { withRouter, Link } from 'react-router-dom';
import { UserType } from '@upstart/harmony/lib/legos/constants';

import AddButton from './AddButton';
import EmployeeAddButton from './EmployeeAddButton';
import EditButton from './EditButton';
import EmployeeEditButton from './EmployeeEditButton';
import ErrorMessage from '../ErrorMessage';
import './UserList.scss';
import UsersToCSVButton from '../../containers/Users/UsersToCSVButton';

class UserList extends PureComponent {
  actionFormatter = (cell, user) => {
    const EditButtonComponent = user.dealer_id
      ? EditButton
      : EmployeeEditButton;
    return (
      <EditButtonComponent
        user={user}
        history={this.props.history}
        onDelete={this.props.onDelete}
        onUnlock={this.props.onUnlock}
      />
    );
  };

  createCustomInsertButton = dealerId => {
    if (dealerId) {
      return (
        <>
          <AddButton dealerId={dealerId} />
          <Link
            className="btn btn-primary btn-large new-btn-space"
            to={{ pathname: `/${dealerId}/users/import/crm/` }}
          >
            Import from CRM
          </Link>
          <Link
            className="btn btn-primary btn-large new-btn-space"
            to={{ pathname: `/${dealerId}/users/import/csv/` }}
          >
            Import from CSV
          </Link>
        </>
      );
    }
    return (
      <div className="btn-group btn-group-sm">
        <EmployeeAddButton />
        <UsersToCSVButton
          userType={UserType.EMPLOYEE}
          label="Export employee users"
        />
        <UsersToCSVButton
          userType={UserType.ADVANCED}
          label="Export advanced users"
        />
      </div>
    );
  };

  roleFormatter = (cell, row) => {
    const { roles } = row;
    return (
      <div>
        {roles.map(role => (
          <div> {role} </div>
        ))}
      </div>
    );
  };

  render() {
    const { list, error, dealer, showCrmUserId } = this.props;

    const options = {
      insertBtn: () => this.createCustomInsertButton(dealer.id),
    };

    return (
      <div className="user-list-container">
        {error && <ErrorMessage error={error} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
          data-dd-privacy="mask"
          className="amp-mask"
        >
          <TableHeaderColumn
            isKey
            dataField="crmUserId"
            hidden={!showCrmUserId}
          >
            CRM User ID
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="firstName"
            dataSort
            filter={{ type: 'TextFilter', defaultValue: '' }}
          >
            First Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="lastName" dataSort>
            Last Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="email">Email</TableHeaderColumn>
          <TableHeaderColumn dataField="phone">Phone</TableHeaderColumn>
          <TableHeaderColumn dataField="roles" dataFormat={this.roleFormatter}>
            Role
          </TableHeaderColumn>
          <TableHeaderColumn dataField="type">Type</TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

UserList.propTypes = {
  dealer: PropTypes.object,
  showCrmUserId: PropTypes.bool,
  error: PropTypes.any,
  list: PropTypes.array,
  onDelete: PropTypes.func,
  onUnlock: PropTypes.func,
  history: PropTypes.object,
};

export default withRouter(UserList);
